import { observer } from "mobx-react";
import { observable } from "mobx";
import * as React from "react";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { Chart } from "@antv/g2";
import { AgendamentosAdminStore } from "../../stores/admin/AgendamentoAdminStore";
import { AppStore } from "../../stores/AppStore";
import { FormGroup, HTMLSelect } from "@blueprintjs/core";
import { toast } from "react-toastify";


@observer
export class AgendamentosAdminPage extends React.Component<{}, {}> {

  obs = observable({
    tipo_integracao: "" as string
  });

  private mensalContainerRef = React.createRef<HTMLDivElement>();

  private quinzenalContainerRef = React.createRef<HTMLDivElement>();

  private semanalContainerRef = React.createRef<HTMLDivElement>();

  private mensalChart?: Chart;
  private quinzenalChart?: Chart;
  private semanalChart?: Chart;

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Agendamentos - Admin");
  }

  componentDidMount(): void {

    this.renderOrUpdateG2();

  }

  componentDidUpdate(): void {

    this.renderOrUpdateG2();

  }

  private handleAlterarTipoIntegracao = (e: React.ChangeEvent<HTMLSelectElement>): void => {

    this.obs.tipo_integracao = e.target.value;

    AgendamentosAdminStore.handleLimparResumoAgendamentos();

  };

  private handleGerar = async (): Promise<void> => {

    const tipoIntegracao =
      String(this.obs.tipo_integracao || "").trim();

    if (!tipoIntegracao) {

      toast.warning("Selecione um tipo de integração.");
      return;
    }

    await AgendamentosAdminStore.handleGetResumoAgendamentos(tipoIntegracao);
  };

  handleTipoIntegracao() {
    return (
      <>
        <option disabled value="">Selecione uma opção</option>
        <option value={"cnds"}>CNDS</option>
        <option value={"sefa"}>SEFA AGENDAMENTOS</option>
        <option value={"fgts"}>FGTS</option>
        <option value={"parauapebas"}>PARAUAPEBAS</option>
      </>
    );
  }

  componentWillUnmount(): void {

    this.mensalChart?.destroy();
    this.quinzenalChart?.destroy();
    this.semanalChart?.destroy();

    this.mensalChart = undefined;
    this.quinzenalChart = undefined;
    this.semanalChart = undefined;

    AgendamentosAdminStore.handleLimparResumoAgendamentos();

  }

  private formatarNumero = (
    valor: any
  ): string => {

    return new Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 0,
    }).format(Number(valor) || 0);

  };

  private formatarDiaSemana = (
    dia: any
  ): string => {

    return String(dia || "")
      .replace(/^\d+\./, "");

  };

  private criarOuAtualizarGrafico(
    chartAtual: Chart | undefined,
    container: HTMLDivElement | null,
    data: any[],
    formatadorDia: (valor: any) => string,
    columnWidthRatio: number
  ): Chart | undefined {

    if (!container) {
      return chartAtual;
    }

    let chart = chartAtual;

    if (!chart) {
      chart = new Chart({
        container,
        autoFit: true,
        height: 350,
      });
    }

    chart.options({
      type: "interval",
      autoFit: true,
      data,

      legend: false,

      encode: {
        x: "dia",
        y: "empresas",
      },

      style: {
        columnWidthRatio,
      },

      scale: {
        y: {
          nice: true,
        },
      },

      tooltip: {
        title: (item: any) => {
          return formatadorDia(item.dia);
        },

        items: [
          {
            field: "empresas",
            name: "Empresas",

            valueFormatter: (valor: any) => {
              return `${this.formatarNumero(valor)} empresas`;
            },
          },
        ],
      },

      axis: {
        y: {
          title: "Quantidade de empresas",

          labelFormatter: (valor: any) =>
            this.formatarNumero(valor),

          grid: true,
          gridLineWidth: 1.5,
          gridStrokeOpacity: 0.35,

          line: true,
          lineLineWidth: 1.5,

          tick: true,
          tickLineWidth: 1.5,
          tickStrokeOpacity: 0.6,
        },

        x: {
          title: false,
          labelFormatter: formatadorDia,
        },
      },
    });

    chart.render();

    return chart;
  }

  private renderOrUpdateG2(): void {

    const isSomenteMensal = ["fgts", "cnds"].includes(this.obs.tipo_integracao);

    this.mensalChart =
      this.criarOuAtualizarGrafico(
        this.mensalChart,
        this.mensalContainerRef.current,
        AgendamentosAdminStore.getDadosMensais(),
        (dia: any) => `Dia ${dia}`,
        0.30
      );

    if (isSomenteMensal) {

      this.quinzenalChart?.destroy();
      this.semanalChart?.destroy();

      this.quinzenalChart = undefined;
      this.semanalChart = undefined;

      return;
    }

    this.quinzenalChart =
      this.criarOuAtualizarGrafico(
        this.quinzenalChart,
        this.quinzenalContainerRef.current,
        AgendamentosAdminStore.getDadosQuinzenais(),
        (dia: any) => `Dia ${dia}`,
        0.30
      );

    this.semanalChart =
      this.criarOuAtualizarGrafico(
        this.semanalChart,
        this.semanalContainerRef.current,
        AgendamentosAdminStore.getDadosSemanais(),
        this.formatarDiaSemana,
        0.30
      );
  }

  render() {

    const loading = AgendamentosAdminStore.obs.loading_resumo_agendamentos;

    const isSomenteMensal = ["fgts", "cnds"].includes(this.obs.tipo_integracao);

    return (
      <>

        <div style={{ display: "flex", marginBottom: 20 }}>
          <FormGroup
            label="Tipo Integração"
            className="inputsPeriodoCalculos"
            style={{ width: 200, marginRight: 15 }}
          >
            <HTMLSelect
              value={this.obs.tipo_integracao}
              disabled={loading}
              onChange={this.handleAlterarTipoIntegracao}
            >
              {this.handleTipoIntegracao()}
            </HTMLSelect>
          </FormGroup>

          <FormGroup label={"​"}>
            <MDBBtn
              style={{ marginTop: 5 }}
              className="btnDefault btnBuscarNfe"
              onClick={this.handleGerar}
              disabled={loading}
            >
              {loading ? "Gerando..." : "Gerar"}
            </MDBBtn>
          </FormGroup>
        </div>

        <MDBRow>
          <MDBCol md="12">
            <MDBRow>

              <MDBCol
                lg={isSomenteMensal ? "12" : "6"}
                md="12"
                className="mb-3"
              >
                <div className="blocoProcesso">

                  <h3 className="titleProccess">
                    Mensal — dia do mês
                  </h3>

                  <div
                    style={{
                      width: "100%",
                      minHeight: 350,
                      marginTop: 10,
                    }}
                  >
                    <div ref={this.mensalContainerRef} />
                  </div>

                </div>
              </MDBCol>

              {!isSomenteMensal && (
                <MDBCol
                  lg="6"
                  md="12"
                  className="mb-3"
                >
                  <div className="blocoProcesso">

                    <h3 className="titleProccess">
                      Quinzenal — dia do mês
                    </h3>

                    <div
                      style={{
                        width: "100%",
                        minHeight: 350,
                        marginTop: 10,
                      }}
                    >
                      <div ref={this.quinzenalContainerRef} />
                    </div>

                  </div>
                </MDBCol>
              )}

            </MDBRow>
          </MDBCol>

          {!isSomenteMensal && (
            <MDBCol md="12">
              <MDBRow>

                <MDBCol
                  lg="12"
                  md="12"
                  className="mb-3"
                >
                  <div className="blocoProcesso">

                    <h3 className="titleProccess">
                      Semanal — dia da semana
                    </h3>

                    <div
                      style={{
                        width: "100%",
                        minHeight: 350,
                        marginTop: 10,
                      }}
                    >
                      <div ref={this.semanalContainerRef} />
                    </div>

                  </div>
                </MDBCol>

              </MDBRow>
            </MDBCol>
          )}

        </MDBRow>
      </>
    );
  }
}